/* eslint-disable eqeqeq */

import { Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import API from "../../API";
import { ShowContext } from "../../App";
import CircularTable from "./CircularTable";
import { uploadFileInChunks } from "../../utils/Helper";
import FormField from "../../utils/FormField";

let initialValues = {
    heading: "",
    url: "",
    date: "",
    fromDate: "",
    toDate: "",
    type: "",
    file: "",
    category: 1,
};

const Circular = () => {
    const { setShow, setMsg } = useContext(ShowContext);
    const [circularData, setCircularData] = useState(null);
    const [edit, setEdit] = useState(false);
    const [editValues, setEditValues] = useState();
    const [myInitialValues, setMyInitialValues] = useState(initialValues);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getCirculardata(setCircularData, 1);
    }, []);
    useEffect(() => {
        if (editValues) {
            setMyInitialValues({ ...editValues });
        }
    }, [editValues]);
    return (
        <div className="py-3">
            <Formik
                initialValues={myInitialValues}
                enableReinitialize={true}
                validateOnBlur={true}
                onSubmit={(values, actions) => {
                    setLoading(true)
                    submitCircular(
                        values,
                        setLoading
                    );
                    actions.resetForm({
                        values: initialValues,
                    });
                }}
                validationSchema={Yup.object({
                    heading: Yup.string().required("Heading is Required"),
                    type: Yup.string().required("Type is Required"),
                    fromDate: Yup.string().required("Start Date is Required"),
                    toDate: Yup.string().required("End Date is Required"),
                    file: !editValues && Yup.string()
                        .ensure()
                        .when(["type"], {
                            is: (type) => type == 1,
                            then: Yup.string().required("PDF is Required"),
                        }),
                    url: Yup.string()
                        .ensure()
                        .when(["type"], {
                            is: (type) => type != 1,
                            then: Yup.string().required("URL is Required"),
                        }),
                    date: Yup.string().required("Announcement Date is Required"),
                    category: Yup.string().required("Category is Required"),
                })}
            >
                {(props) => {
                    const {
                        values,
                        errors,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        setFieldValue,
                    } = props;
                    return (
                        <>
                            <div className="card card-body">
                                <form
                                    id="form-client"
                                    method="post"
                                    className="form-horizontal"
                                    onSubmit={handleSubmit}
                                >
                                    <div className="form-group row ">
                                        <div className="col-sm-12 col-md-12 col-lg-12">
                                            <h3 className="text-center">Add Circular</h3>
                                            <div className="col-sm-4 col-md-12 col-lg-12"></div>
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-6 col-md-6 col-lg-6">
                                            <FormField
                                                values={values}
                                                heading={"Heading"}
                                                name="heading"
                                            />
                                        </div>
                                        <div className="col-sm-2 col-md-2 col-lg-2">
                                            <FormField
                                                values={values}
                                                heading={"Type"}
                                                name="type"
                                                as="select"
                                                options={[
                                                    <option value={1}>PDF</option>,
                                                    <option value={2}>Web URL</option>
                                                ]}
                                            />
                                        </div>
                                        <div className="col-sm-4 col-md-4 col-lg-4">
                                            <FormField
                                                values={values}
                                                heading={"Category"}
                                                name="category"
                                                as="select"
                                                options={[
                                                    <option value={1}>Circular/Office Order</option>,
                                                    <option value={2}>Seminar/Conference/Workshop</option>,
                                                    <option value={3}>Trainings</option>,
                                                    <option value={4}>Government Resolutions</option>,
                                                    <option value={5}>Important Act</option>,
                                                    <option value={6}>Downloads</option>
                                                ]}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        {values.type == 1 ? (
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <label
                                                    htmlFor="file"
                                                    className="formLable"
                                                >
                                                    File
                                                </label>
                                                <div className="">
                                                    <input
                                                        type="file"
                                                        id="file"
                                                        name="file"
                                                        placeholder="PDF"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            handleChange(event);
                                                            setFieldValue(
                                                                "file_binary",
                                                                event.currentTarget.files[0]
                                                            );
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    {errors.file ? (
                                                        <div className="text-danger">
                                                            {errors.file}
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <FormField
                                                    values={values}
                                                    heading={"URL"}
                                                    name="url"
                                                />
                                            </div>
                                        )}
                                        <div className="col-sm-6 col-md-6 col-lg-6">
                                            <FormField
                                                values={values}
                                                heading={"Date"}
                                                name="date"
                                                type="datetime-local"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <div className="col-sm-6 col-md-6 col-lg-6">
                                            <FormField
                                                values={values}
                                                heading={"Start Date (date and time)"}
                                                name="fromDate"
                                                type="datetime-local"
                                            />
                                        </div>
                                        <div className="col-sm-6 col-md-6 col-lg-6">
                                            <FormField
                                                values={values}
                                                heading={"End Date (date and time)"}
                                                name="toDate"
                                                type="datetime-local"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 d-flex justify-content-center">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className="btn btn-primary mx-2"
                                        >
                                            {loading && <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
                                            {editValues ? "Edit" : "Submit"}
                                        </button>
                                        {editValues && (
                                            <button
                                                onClick={(e) => {
                                                    setMyInitialValues(initialValues);
                                                    setEditValues();
                                                    setEdit(false);
                                                }}
                                                disabled={loading}
                                                className="btn btn-primary mx-2"
                                            >
                                                Cancel
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                            <br />
                        </>
                    );
                }}
            </Formik>
            <div className="card card-body">
                <CircularTable
                    circularData={circularData}
                    setCircularData={setCircularData}
                    edit={edit}
                    setEdit={setEdit}
                    editValues={editValues}
                    setEditValues={setEditValues}
                    getCirculardata={getCirculardata}
                />
            </div>
        </div>
    );

    async function submitCircular(
        values,
        setSubmitting
    ) {
        // console.log(values);

        var flag = 0;
        var fileUrl = "";
        if (values.file) {
            //-------------------Send file then store values-----------------------
            try {
                fileUrl = await uploadFileInChunks(values.file_binary, "circular")
                flag = 1;
            } catch (err) {
                console.error("Error uploading file:", err);
                flag = 0;
            }
        } else {
            //---------------------------Store values directly---------------------
            flag = 1;
        }

        if (flag) {
            let fd = new FormData();
            fd.append("heading", values.heading);
            fd.append("type", values.type);
            fd.append("fromDate", values.fromDate);
            fd.append("toDate", values.toDate);
            fd.append("date", values.date);
            fd.append("category", values.category);
            if (values.file) {

                fd.append("file", fileUrl);
            }
            if (values.url) {
                fd.append("url", values.url);
            }

            if (values.id) {
                fd.append("id", values.id);

                //-----------update-------
                await API.post("/circulars/edit", fd)
                    .then((res) => {
                        if (res.data.status === "success") {
                            setCircularData((pre) => ({
                                ...pre,
                                data: pre.data.map((rec) => {
                                    if (rec.id !== values.id) {
                                        return rec;
                                    } else {
                                        return { ...rec, ...res.data.data };
                                    }
                                }),
                            }));

                            setEdit(false);
                            setEditValues();
                            setShow(true);
                            setMsg(res.data.message);
                        }
                        setSubmitting(false)
                    })
                    .catch((error) => {
                        console.log(error);
                        setSubmitting(false)
                    });
            } else {
                //---------create---------------
                await API.post("/circulars", fd)
                    .then((res) => {
                        if (res.data.status === "success") {
                            setCircularData((pre) => ({
                                ...pre,
                                data: [...pre.data, res.data.data]
                            }));
                            setShow(true);
                            setMsg(res.data.message);
                        }
                        setSubmitting(false)
                    })
                    .catch((error) => {
                        console.log(error);
                        setSubmitting(false)
                    })
            }
        }
    }

    async function getCirculardata(setCircularData, page) {
        try {
            const res = await API.get("/circulars", { params: { page } })
            if (res.data.status === "success") {
                let data = res.data.data

                console.log(data);
                setCircularData(data);
            }
        } catch (error) {
            console.log(error);
        }
    }
};

export default Circular;
